
export const Roles = [
    { name: 'Admin', key: 'admin' },
]
